import OffreEnteteController from './offre.entete.controller';
import Template from './offre.entete.html';

export default {
	bindings: {
		offre: '=',
		isOpen: '=',
		dateDemandeCreation: '=',
		personnes: '=',
		isValidate: '=',
		responseValidation: '&',
		isUserCanModifyOffer: '=',
		calculerDateFinCreation: '&',
		getTooltipCalculDate: '&'
	},
	template: Template,
	controller: OffreEnteteController
};
